import React from 'react';

import styled from 'styled-components';

import UsersAdminToolbar from './UsersAdminToolbar';
import UsersTableBody from '../components/AdminUsers/UsersTableBody';
import UsersTablePagination from '../components/AdminUsers/UsersTablePagination';

const StyledPanelContainer = styled.div`
    margin-bottom: 28px;
`;

const UsersAdmin: React.FC = () => (
    <StyledPanelContainer>
        <UsersAdminToolbar />
        <UsersTableBody />
        <UsersTablePagination />
    </StyledPanelContainer>
);

export default UsersAdmin;
